const storageTrigger = document.querySelector('.js-storage-trigger');
const storageInfo = document.querySelector('.js-storage-info');
const megaNav = document.querySelector('.custom-mega-navigation');
const meganavOverlay = document.querySelector('.custom-mega-navigation__overlay');
const meganavTrigger = meganavOverlay.previousElementSibling;
const meganavContainer = meganavOverlay.nextElementSibling;
const productTileImages = document.querySelectorAll('.product-tile__image');

productTileImages.forEach(tile => {
  tile.addEventListener('mouseover', function() {
    this.classList.add('zoom');
  });
  tile.addEventListener('mouseout', function() {
    this.classList.remove('zoom');
  });
});

function showStorageInfo() {
  storageInfo.classList.add('is-visible');
}

function hideStorageInfo() {
  storageInfo.classList.remove('is-visible');
}

if (storageTrigger) {
  storageTrigger.addEventListener('mouseover', showStorageInfo);
  storageTrigger.addEventListener('mouseout', hideStorageInfo);
}

meganavOverlay.addEventListener('click', function(e) {
    meganavTrigger.classList.remove('nav__menu--active');
    meganavContainer.classList.remove('visible');
});

meganavContainer.addEventListener('click', function(e) {
  if (e.target !== megaNav) {
    meganavTrigger.classList.remove('nav__menu--active');
    meganavContainer.classList.remove('visible');
  }
})
